var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeGrey = function SvgYoutubeGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12.372,
    viewBox: "0 0 18 12.372",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-grey-icon",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M17.234,4.192c-.488-.869-1.016-1.028-2.1-1.089S11.349,3,9,3s-5.064.03-6.14.1S1.255,3.323.762,4.2,0,6.553,0,9.184v.009c0,2.618.259,4.12.762,4.979s1.023,1.026,2.1,1.1,3.789.1,6.141.1,5.057-.038,6.136-.1,1.609-.234,2.1-1.1c.507-.859.764-2.363.764-4.982V9.182c0-2.631-.256-4.125-.765-4.993Z",
    transform: "translate(0 0)",
    fill: "#7c98b6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M6,12.25V5.5l5.625,3.375Z",
    transform: "translate(0.75 0.313)",
    fill: "#fafafa",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube-grey.0fccdfbc.svg";
export { ForwardRef as ReactComponent };